<template>
    <div class="section-title" :class="[variant, { 'has-accent-bar': accentBar }]">

        <!-- Barra de acento -->
        <span v-if="accentBar" class="section-accent-bar"></span>

        <!-- Icono -->
        <i v-if="icon" :class="['bx', icon, 'section-icon']"></i>

        <!-- Texto -->
        <h5 class="section-text" v-html="title"></h5>

        <!-- Separador -->
        <div class="section-divider"></div>
    </div>
</template>

<script>
export default {
    name: "SectionTitle",

    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: null
        },
        variant: {
            type: String,
            default: "default"
        },
        accentBar: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
/* =========================
   CONTENEDOR BASE
========================= */
.section-title {
    display: flex;
    align-items: flex-start;
    /* 🔴 clave para multiline */
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

/* =========================
   ACCENT BAR
========================= */
.section-accent-bar {
    width: 4px;
    background-color: var(--accent-warning);
    border-radius: 2px;
    align-self: stretch;
    /* 🔴 ocupa todo el alto del título */
}

/* =========================
   ICONO
========================= */
.section-icon {
    font-size: 1.5rem;
    color: var(--title2-color-primary);
    line-height: 1;
}

/* =========================
   TEXTO
========================= */
.section-text {
    margin: 0;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--text-primary);
    white-space: nowrap;
    /* desktop: una sola línea */
}

/* =========================
   DIVISOR
========================= */
.section-divider {
    flex-grow: 1;
    height: 1px;
    background-color: var(--border-light);
    margin-left: 1rem;
    align-self: center;
}

/* =========================
   VARIANT ACCENT
========================= */
.section-title.accent .section-divider {
    height: 2px;
    background-color: var(--accent-warning);
}

.section-title.accent .section-text strong {
    color: var(--title-color);
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 576px) {
    .section-title {
        flex-wrap: wrap;
    }

    .section-text {
        white-space: normal;
        /* 🔴 ahora sí se parte en líneas */
        line-height: 1.25;
    }

    .section-divider {
        width: 100%;
        margin: 0.5rem 0 0 0;
    }
}
</style>
